import { render, staticRenderFns } from "./FormatObjectSelector.vue?vue&type=template&id=3a270fd2&"
import script from "./FormatObjectSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports